export default __webpack_public_path__ + "static/media/plus.9891da7f.svg";